"use client"

import { Col, Row } from "antd"
import ProductPreview from "./ProductPreview"
import { useRef } from "react"
import { storeRef } from "@/components/providers/StoreProvider"
import { productActions } from "@/lib/redux/features/product/reduce"
import { TypeProductDetail } from "@/lib/redux/features/product/type"
import ProductPanel from "./ProductPanel"
import ProductNoDesign from "../ProductNoDesign"
import PopupContainer from "@/components/common/Popups/container"
import { Discount, TypeStoreDetail } from "@/lib/redux/features/store/type"

type ProductProps = {
  productDetail: TypeProductDetail,
  discountDetail: Discount | null
  store: TypeStoreDetail
}

const Product = ({ productDetail, discountDetail, store }: ProductProps) => {
  const refSSR = useRef<any>(null)

  if (!refSSR.current) {
    refSSR.current = true
    storeRef.current?.dispatch(productActions.setProductDetailData(productDetail))
  }

  if (productDetail.no_design && !productDetail.bundle) {
    return (
      <ProductNoDesign />
    )
  }

  return (
    <Row justify="center" className="page product">
      <PopupContainer page='product' />
      <Col className="page__section">
        <Row justify="center" gutter={[15, 15]}>
          <Col xs={24} md={24} lg={15} xl={{ flex: 1 }}>
            <Row>
              <Col span={24}>
                <ProductPreview store={store} />
              </Col>
            </Row>

          </Col>
          <Col xs={24} md={20} lg={9} xl={{ flex: "45rem" }}>
            <Row>
              <Col span={24}>
                <ProductPanel discountDetail={discountDetail} store={store}  />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default Product